import React from "react";
import { SubToPages_pages } from "../../api/SubToPages";
import { SliderFontSizeProvider } from "../SliderFontSize/context";
import EditingRouter from "./EditingRouter";

type Props = {
  projectId: string;
  pages: SubToPages_pages[];
  loading: boolean;
};

const EditingRouterProvider = (props: Props) => {
  return (
    <SliderFontSizeProvider>
      <EditingRouter {...props} />
    </SliderFontSizeProvider>
  );
};

export default EditingRouterProvider;
